export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";